//@flow
import {
    HiverAxios, HiverChatBifrostAuth, HiverIntegrationAxios, sendTrackingEvent,
    isIntegrationNewAuthEnabled, showMessage, isFeatureEnabled, HiverIntegrationBifrostAuth, 
    isHiverApiDomainEnabled, isNewChatAuthEnabled,
} from 'h-commons';
import { config } from '../../../../config';
import {
    DELETE_SM_DONE,
    DELETE_SM_FAILED,
    DELETE_SM_INIT,
    DELETE_CHAT_INBOX_DONE,
    DELETE_CHAT_INBOX_INIT,
    DELETE_CHAT_INBOX_FAILED,
    DELETE_WHATSAPP_INBOX_DONE,
    DELETE_WHATSAPP_INBOX_INIT,
    DELETE_WHATSAPP_INBOX_FAILED,
    DELETE_VOICE_INBOX_INIT,
    DELETE_VOICE_INBOX_DONE,
    DELETE_VOICE_INBOX_FAILED,
} from './types';
import { NewMWApi } from '../../../common/constants/NewChannelsMWApi';
import { fetchDashboardDetails } from '../../../dashboard/actions';

export const deleteSharedmailbox = (smId: number) => (dispatch: Function) => {
    dispatch({ type: DELETE_SM_INIT });
    HiverAxios({
        url: `/gx/api/sm/${smId}`,
        type: 'DELETE',
        callback: (resp) => {
            if (resp.data) {
                dispatch(fetchDashboardDetails());
                dispatch({ type: DELETE_SM_DONE, payload: smId });
                sendTrackingEvent('smRemoved');
            } else
                dispatch({ type: DELETE_SM_FAILED, payload: smId });
        },
        onfail: () => dispatch({ type: DELETE_SM_FAILED, payload: smId })
    });
};

export const deleteSharedInbox = (channelId: number, availableFeatures: Array<Object>) => (dispatch: Function) => {
    const isJwtType = isFeatureEnabled(availableFeatures, NewMWApi.JWT_FEATURE_KEY),
        url = isJwtType ? NewMWApi?.deleteSpecificChannelInbox?.middleWare?.url :
            NewMWApi?.deleteSpecificChannelInbox?.v2?.url,
        type = NewMWApi?.deleteSpecificChannelInbox?.type;
    const isNewAuthEnabled =  isNewChatAuthEnabled(availableFeatures);
    const isHiverApiDomain = isHiverApiDomainEnabled(availableFeatures);

    dispatch({ type: DELETE_CHAT_INBOX_INIT });
    if (isNewAuthEnabled) {
    HiverChatBifrostAuth({
        url: url.replaceAll('{{inbox-id}}', channelId),
        method: type,
        isHiverApiDomain,
    }, false, isJwtType)
    .then(resp => {
        if (resp.status === 200) {
            dispatch(fetchDashboardDetails());
            dispatch({ type: DELETE_CHAT_INBOX_DONE, payload: channelId });
        } else {
            dispatch({ type: DELETE_CHAT_INBOX_FAILED, payload: channelId });
        }
    })
    .catch(() => dispatch({ type: DELETE_CHAT_INBOX_FAILED, payload: channelId }));
    }
    else {
    HiverAxios({
        url: url.replaceAll('{{inbox-id}}', channelId),
        type,
        root_url: config.CHANNELS_MW_URL,
        callback: (resp) => {
            if (resp.status == 200) {
                dispatch(fetchDashboardDetails());
                dispatch({ type: DELETE_CHAT_INBOX_DONE, payload: channelId });
            } else
                dispatch({ type: DELETE_CHAT_INBOX_FAILED, payload: channelId });
        },
        onfail: () => dispatch({ type: DELETE_CHAT_INBOX_FAILED, payload: channelId })
    }, false, isJwtType);
    }
};

export const deleteWhatsappInbox = (channelId: number, selectedSMName: string, availableFeatures: Array<Object>) => (dispatch: Function) => {
    const isJwtType = isFeatureEnabled(availableFeatures, NewMWApi.JWT_FEATURE_KEY),
        url = isJwtType ? NewMWApi?.deleteSpecificChannelInbox?.middleWare?.url :
            NewMWApi?.deleteSpecificChannelInbox?.v2?.url,
        type = NewMWApi?.deleteSpecificChannelInbox?.type;
    const isNewAuthEnabled =  isNewChatAuthEnabled(availableFeatures);
    const isHiverApiDomain = isHiverApiDomainEnabled(availableFeatures);
    dispatch({ type: DELETE_WHATSAPP_INBOX_INIT });
    if (isNewAuthEnabled) {
    HiverChatBifrostAuth({
        url: url.replaceAll('{{inbox-id}}', channelId),
        method: type,
        isHiverApiDomain,
    }, false, isJwtType)
    .then(async (resp) => {
        if (resp.status === 200) {
            await dispatch(fetchDashboardDetails());
            dispatch({ type: DELETE_WHATSAPP_INBOX_DONE, payload: channelId });
            showMessage({
                message: `WhatsApp inbox ${selectedSMName} has been deleted.`,
                type: 'success',
            });
            sendTrackingEvent('whatsappSMRemoved');
        } else {
            dispatch({ type: DELETE_WHATSAPP_INBOX_FAILED, payload: channelId });
        }
    })
    .catch(() => dispatch({ type: DELETE_WHATSAPP_INBOX_FAILED, payload: channelId }));
    }
    else {
    HiverAxios({
        url: url.replaceAll('{{inbox-id}}', channelId),
        type,
        root_url: config.CHANNELS_MW_URL,
        callback: async (resp) => {
            if (resp.status == 200) {
                await dispatch(fetchDashboardDetails());
                dispatch({ type: DELETE_WHATSAPP_INBOX_DONE, payload: channelId });
                showMessage({
                    message: `WhatsApp inbox ${selectedSMName} has been deleted.`,
                    type: 'success',
                });
                sendTrackingEvent('whatsappSMRemoved');
            } else
                dispatch({ type: DELETE_WHATSAPP_INBOX_FAILED, payload: channelId });
        },
        onfail: () => dispatch({ type: DELETE_WHATSAPP_INBOX_FAILED, payload: channelId })
    }, false, isJwtType);
    }
};

export const deleteVoiceInbox =
  (channelId: number, availableFeatures: Array<Object>) => (dispatch: Function) => {
    const isNewAuthEnabled = isIntegrationNewAuthEnabled(availableFeatures);
    const isHiverApiDomain = isHiverApiDomainEnabled(availableFeatures);
    dispatch({ type: DELETE_VOICE_INBOX_INIT });
    if (isNewAuthEnabled){
        HiverIntegrationBifrostAuth({
            url: `/v1/integrations/channels/inboxes/${channelId}`,
            method:'DELETE',
            isHiverApiDomain,
        }).then(
            resp => {
                if (resp.status == 204) {
                    dispatch(fetchDashboardDetails());
                    dispatch({ type: DELETE_VOICE_INBOX_DONE, payload: channelId });
                } else {
                    dispatch({ type: DELETE_VOICE_INBOX_FAILED, payload: channelId });
                }
            }
        ).catch(
            (err) => {
                dispatch({ type: DELETE_VOICE_INBOX_FAILED, payload: channelId });
            }
        )
    }
    else {
    HiverIntegrationAxios({
        url: `/v1/integrations/channels/inboxes/${channelId}`,
        type: 'DELETE',
        callback: (resp) => {
          if (resp.status == 204) {
              dispatch(fetchDashboardDetails());
              dispatch({ type: DELETE_VOICE_INBOX_DONE, payload: channelId });
          } else {
              dispatch({ type: DELETE_VOICE_INBOX_FAILED, payload: channelId });
          }
        },
        onfail: () =>
          dispatch({ type: DELETE_VOICE_INBOX_FAILED, payload: channelId }),
      });
    }
  };